export function plainCatalogDescription(htmlOrText: string): string {
  return htmlOrText
    .replace(/<[^>]*>/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}
